import React, { useEffect, useRef, useState } from 'react';
import AppSwitcherIcon from '@/images/app-switcher/app-switcher.svg';
import Amira from '@/images/app-switcher/amira.svg';
import Lectura from '@/images/app-switcher/lectura.svg';
import Math from '@/images/app-switcher/math.svg';
import LecturaMath from '@/images/app-switcher/lectura_math.svg';
import './AppSwitcher.scss';
import { Popover } from 'bootstrap';
import { useTranslation } from 'react-i18next';

interface AppSwitcherProps {
  placement: 'top' | 'right' | 'bottom' | 'left';
  entitlement: 'lectura' | 'math' | 'lectura_math';
}

const AppSwitcher: React.FC<AppSwitcherProps> = ({
  entitlement,
  placement,
}) => {
  const { t } = useTranslation(['navigation']);
  const popoverRef = useRef<HTMLButtonElement>(null);
  const popoverContentRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const popoverTriggerEl = popoverRef.current;

    if (popoverTriggerEl) {
      const popoverInstance = new Popover(popoverTriggerEl, {
        html: true,
        sanitize: false, // Allow raw HTML
        placement: placement,
        trigger: 'click',
        content: popoverContentRef.current as HTMLElement,
      });

      const handleClickOutside = (event: MouseEvent) => {
        if (
          popoverInstance &&
          popoverRef.current &&
          !popoverRef.current.contains(event.target as Node)
        ) {
          popoverInstance.hide();
        }
      };

      document.addEventListener('click', handleClickOutside);

      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }
  }, []);

  const getSubscriptionApp = () => {
    let icon;
    let text = '';
    switch (entitlement) {
      case 'lectura':
        icon = Lectura;
        text = t('Lectura');
        break;
      case 'math':
        icon = Math;
        text = t('Math');
        break;
      case 'lectura_math':
        icon = LecturaMath;
        text = t('LecturaMath');
        break;
    }

    if (icon) {
      return (
        <a href={process.env.ISTATION_EDUCATOR_URL}>
          <img src={icon} alt={text} />
          <span>{text}</span>
        </a>
      );
    }
  };

  return (
    <section className="app-switcher-wrapper">
      <button
        className="btn"
        ref={popoverRef}
        type="button"
        data-bs-toggle="popover"
        aria-label={`${t('AppSwitcher')}`}>
        <img
          className="app-switcher-image"
          src={AppSwitcherIcon}
          alt={`${t('AppSwitcher')}`}
        />
      </button>
      <section className="d-none">
        <section
          ref={popoverContentRef}
          className="d-flex flex-column app-switcher-menu"
          style={{ minWidth: '10rem' }}>
          <div>
            <img src={Amira} alt="Amira" />
            <span>{`${t('AmiraReading')}`}</span>
          </div>
          {getSubscriptionApp()}
        </section>
      </section>
    </section>
  );
};

export default AppSwitcher;
